var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("div", { class: { overlay_setting: _vm.isLoadingData } }, [
        _c("i", { class: { loadding_setting: _vm.isLoadingData } })
      ]),
      _c("AppHeader"),
      _c("div", { staticClass: "setting_wrapper" }, [
        _c("main", { staticClass: "setting_main" }, [
          _c("div", { staticClass: "setting_menu" }, [
            _c(
              "ul",
              { staticClass: "setting_menu_list" },
              [
                _c(
                  "li",
                  {
                    staticClass: "setting_menu_item",
                    on: {
                      click: function($event) {
                        return _vm.changeTab(_vm.COMMON_SETTING_TAB)
                      }
                    }
                  },
                  [
                    _c(
                      "a",
                      {
                        staticClass: "setting_menu_link is_active",
                        attrs: { id: "1" }
                      },
                      [
                        _vm._v(
                          "\n              " +
                            _vm._s(_vm.labelProperties.FIRST_TAB) +
                            "\n            "
                        )
                      ]
                    )
                  ]
                ),
                _vm.hp_renkei_entry === 1
                  ? _c(
                      "li",
                      {
                        staticClass: "setting_menu_item",
                        on: {
                          click: function($event) {
                            return _vm.changeTab(_vm.ENTRY_SETTING_TAB)
                          }
                        }
                      },
                      [
                        _c(
                          "a",
                          {
                            staticClass: "setting_menu_link",
                            attrs: { id: "2" }
                          },
                          [
                            _vm._v(
                              "\n              " +
                                _vm._s(_vm.labelProperties.SECOND_TAB) +
                                "\n            "
                            )
                          ]
                        )
                      ]
                    )
                  : _vm._e(),
                _vm.hp_renkei_job === 1
                  ? [
                      _c(
                        "li",
                        {
                          staticClass: "setting_menu_item",
                          on: {
                            click: function($event) {
                              return _vm.changeTab(
                                _vm.DISPLAY_SETTING_SUB_TAB_JOB
                              )
                            }
                          }
                        },
                        [
                          _c(
                            "a",
                            {
                              staticClass: "setting_menu_link",
                              attrs: { id: "7" }
                            },
                            [
                              _vm._v(
                                "\n                " +
                                  _vm._s(
                                    _vm.labelProperties.FIRST_SUB_TAB_JOB
                                  ) +
                                  "\n              "
                              )
                            ]
                          )
                        ]
                      ),
                      _c(
                        "li",
                        {
                          staticClass: "setting_menu_item",
                          on: {
                            click: function($event) {
                              return _vm.changeTab(
                                _vm.SEARCH_SETTING_SUB_TAB_JOB
                              )
                            }
                          }
                        },
                        [
                          _c(
                            "a",
                            {
                              staticClass: "setting_menu_link",
                              attrs: { id: "8" }
                            },
                            [
                              _vm._v(
                                "\n                " +
                                  _vm._s(
                                    _vm.labelProperties.SECOND_SUB_TAB_JOB
                                  ) +
                                  "\n              "
                              )
                            ]
                          )
                        ]
                      ),
                      _c(
                        "li",
                        {
                          staticClass: "setting_menu_item",
                          on: {
                            click: function($event) {
                              return _vm.changeTab(
                                _vm.REFERRAL_SETTING_SUB_TAB_JOB
                              )
                            }
                          }
                        },
                        [
                          _c(
                            "a",
                            {
                              staticClass: "setting_menu_link",
                              attrs: { id: "9" }
                            },
                            [
                              _vm._v(
                                "\n                " +
                                  _vm._s(
                                    _vm.labelProperties.THIRD_SUB_TAB_JOB
                                  ) +
                                  "\n              "
                              )
                            ]
                          )
                        ]
                      ),
                      _vm.is_plan_dispatch_basic === 1 &&
                      _vm.hp_renkei_job === 1
                        ? _c(
                            "li",
                            {
                              staticClass: "setting_menu_item",
                              on: {
                                click: function($event) {
                                  return _vm.changeTab(
                                    _vm.DISPATCH_JOB_SETTING_TAB
                                  )
                                }
                              }
                            },
                            [
                              _c(
                                "a",
                                {
                                  staticClass: "setting_menu_link",
                                  attrs: { id: "4" }
                                },
                                [
                                  _vm._v(
                                    "\n                " +
                                      _vm._s(_vm.labelProperties.SIXTH_TAB) +
                                      "\n              "
                                  )
                                ]
                              )
                            ]
                          )
                        : _vm._e()
                    ]
                  : _vm._e(),
                _c(
                  "li",
                  {
                    staticClass: "setting_menu_item",
                    on: {
                      click: function($event) {
                        return _vm.changeTab(_vm.MASTER_SETTING_TAB)
                      }
                    }
                  },
                  [
                    _c(
                      "a",
                      { staticClass: "setting_menu_link", attrs: { id: "5" } },
                      [
                        _vm._v(
                          "\n              " +
                            _vm._s(_vm.labelProperties.FOURTH_TAB) +
                            "\n            "
                        )
                      ]
                    )
                  ]
                ),
                _vm.hp_renkei_job === 1
                  ? _c(
                      "li",
                      {
                        staticClass: "setting_menu_item",
                        on: {
                          click: function($event) {
                            return _vm.changeTab(_vm.JOB_INFORMATION_TAB)
                          }
                        }
                      },
                      [
                        _c(
                          "a",
                          {
                            staticClass: "setting_menu_link",
                            attrs: { id: "6" }
                          },
                          [
                            _vm._v(
                              "\n              " +
                                _vm._s(_vm.labelProperties.FIFTH_TAB) +
                                "\n            "
                            )
                          ]
                        )
                      ]
                    )
                  : _vm._e()
              ],
              2
            )
          ]),
          _vm.tab === _vm.COMMON_SETTING_TAB && !_vm.isLoadingData
            ? _c(
                "div",
                [
                  _c("CommonSettings", {
                    attrs: {
                      groupName: _vm.groupName,
                      hp_renkei_entry: _vm.hp_renkei_entry,
                      hp_renkei_job: _vm.hp_renkei_job,
                      is_plan_dispatch_basic: _vm.is_plan_dispatch_basic,
                      unSavedData: _vm.unSavedData,
                      userId: _vm.userId,
                      token: _vm.token
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.tab === _vm.ENTRY_SETTING_TAB && !_vm.isLoadingData
            ? _c(
                "div",
                [
                  _c("EntryScreenSettings", {
                    attrs: {
                      entryPageName: _vm.entryPageName,
                      entryOverview: _vm.entryOverview,
                      groupName: _vm.groupName,
                      unSavedData: _vm.unSavedData,
                      userId: _vm.userId,
                      token: _vm.token,
                      hp_renkei_job: _vm.hp_renkei_job,
                      hp_renkei_entry: _vm.hp_renkei_entry,
                      is_plan_dispatch_basic: _vm.is_plan_dispatch_basic
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.tab === _vm.MASTER_SETTING_TAB && !_vm.isLoadingData
            ? _c(
                "div",
                [
                  _c("MasterSettings", {
                    attrs: {
                      groupName: _vm.groupName,
                      unSavedData: _vm.unSavedData,
                      userId: _vm.userId,
                      token: _vm.token
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.tab === _vm.JOB_INFORMATION_TAB && !_vm.isLoadingData
            ? _c(
                "div",
                [
                  _c("JobInformation", {
                    attrs: {
                      groupName: _vm.groupName,
                      userId: _vm.userId,
                      token: _vm.token
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.tab === _vm.DISPLAY_SETTING_SUB_TAB_JOB && !_vm.isLoadingData
            ? _c(
                "div",
                [
                  _c("ButtonAndThemeSettings", {
                    attrs: {
                      groupName: _vm.groupName,
                      jobPageName: _vm.jobPageName,
                      jobOverview: _vm.jobOverview,
                      unSavedData: _vm.unSavedData,
                      userId: _vm.userId,
                      token: _vm.token,
                      commonSetting: _vm.commonSetting
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.tab === _vm.SEARCH_SETTING_SUB_TAB_JOB && !_vm.isLoadingData
            ? _c(
                "div",
                [
                  _c("JobSearchScreenSettings", {
                    attrs: {
                      groupName: _vm.groupName,
                      jobPageName: _vm.jobPageName,
                      jobOverview: _vm.jobOverview,
                      unSavedData: _vm.unSavedData,
                      userId: _vm.userId,
                      token: _vm.token,
                      commonSetting: _vm.commonSetting,
                      is_plan_dispatch_basic: _vm.is_plan_dispatch_basic
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.tab === _vm.REFERRAL_SETTING_SUB_TAB_JOB && !_vm.isLoadingData
            ? _c(
                "div",
                [
                  _c("ReferralSettings", {
                    attrs: {
                      groupName: _vm.groupName,
                      unSavedData: _vm.unSavedData,
                      userId: _vm.userId,
                      token: _vm.token
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.tab === _vm.DISPATCH_JOB_SETTING_TAB && !_vm.isLoadingData
            ? _c(
                "div",
                [
                  _c("DispatchJobSettings", {
                    attrs: {
                      groupName: _vm.groupName,
                      unSavedData: _vm.unSavedData,
                      userId: _vm.userId,
                      token: _vm.token
                    }
                  })
                ],
                1
              )
            : _vm._e()
        ])
      ]),
      _c("AppFooter")
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }